export const setIdentity = (id, peerId, type) => {
  console.log('set', id, peerId, type)
  const name = id === 'X' ? 'Player 1' : 'Player 2';
  return {
    type,
    value: {id, name, peerId}
  }
}


export const resetGrid = (payload) => {
  return function(dispatch) {
    window.conn && window.conn.send({
      activePlayer: 'X',
      gameWinner: null,
      totalTurns: 0,
      grid: payload.grid,
      gridSize: payload.gridSize,
      streak: payload.streak
    });
    dispatch({
      type: 'RESET_GRID',
      ...payload
  
    })
  }
}

export const playTurn = (payload) => {
  return function(dispatch, getState) {
    const state = getState();
    window.conn && window.conn.send({
      gridSize: state.gridSize,
      streak: state.streak,
      grid: payload.grid,
      gameWinner: payload.gameWinner,
      activePlayer: payload.activePlayer,
      totalTurns: payload.totalTurns
    })
    dispatch({
      type: 'PLAY_TURN',
      ...payload
  
    })
  }
}

export const replaceState = (payload) => {
  return {
    type: 'REPLACE_STATE',
    ...payload

  }
}
